import {Component, Input, Output, EventEmitter, ElementRef, ViewChild} from '@angular/core';

@Component({
    selector: 'global-search-results',
    templateUrl: 'global-search-results.component.html',
    styleUrls: ['global-search-results.component.scss']
})
export class GlobalSearchResultsComponent {
    @ViewChild('rejectModal', {read: ElementRef}) rejectModal: ElementRef;
    @ViewChild('rejectModalImage', {read: ElementRef}) rejectModalImage: ElementRef;
    @ViewChild('modalImage', {read: ElementRef}) modalImage: ElementRef;
    @ViewChild('modal', {read: ElementRef}) modal: ElementRef;
    @ViewChild('posterProdImage', {read: ElementRef}) posterProdImage: ElementRef;

    @Input() results = [];
    @Input() searchValue = '';
    @Input() timeTaken = 0;

    @Input() checkboxesEnabled = true;

    @Output() onHandleOpen = new EventEmitter();

    private IMAGE_LOCATION_PREFIX = 'https://cdn-fastly.parrotanalytics.com/images';


    handleResultCheckbox(result) {
        result.checked = !result.checked;
    }

    handleTableRowClick(result) {
        result.collapsed = !result.collapsed;
    }

    handleOpen(result) {
        this.onHandleOpen.emit({
            parrotId: result.parrotId,
            title: result.title,
            displayName: result.displayName,
            catalogState: result.catalogState
        });
    }

    formatCatalogState(catalogState) {
        return catalogState.split('_').map((item) => {
            return item[0].toUpperCase().concat(item.slice(1));
        }).join(' ');
    }

    openImageModal(parrotID: string) {

        const prodImageSrc = `${this.IMAGE_LOCATION_PREFIX}/poster-hyphen/${parrotID}.jpg?unique=${Math.random()}`;
        return prodImageSrc;

    }

}



// WEBPACK FOOTER //
// ./src/app/global-search/global-search-results.component.ts